// extracted by mini-css-extract-plugin
export default {"friends":"Friends_friends__S9zIB"};